export class BillingAddress {

    address = '';
    zip = '';
    state = '';
    country = '';

}
